import * as React from "react";
import styled from "styled-components";
import { SearchForm } from "components/common";
import TeamsQueryHelper from "../../security/components/teams-overview/TeamsQueryHelper";
const Container = styled.div`
  margin-bottom: 10px;
`;
const SyncedTeamsFilter = ({ onSearch }) => /* @__PURE__ */ React.createElement(Container, null, /* @__PURE__ */ React.createElement(
  SearchForm,
  {
    onReset: () => onSearch(""),
    onSearch,
    queryHelpComponent: /* @__PURE__ */ React.createElement(TeamsQueryHelper, null),
    topMargin: 0
  }
));
export default SyncedTeamsFilter;
